import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
type Props = {
  className?: string;
  items: Array<{
    dataTestId?: string;
    label: string;
    onClick?: () => void;
    url?: string;
  }>;
};
export const Breadcrumb = ({ className, items }: Props) =>
  items.length > 1 ? (
    <ul className={classnames('scroll-x scrollbar-hidden flex gap-10 text-14', className)}>
      {items
        .filter(({ label }) => Boolean(label))
        .map((item, i) => (
          <li className="whitespace-nowrap" key={item.label}>
            {i < items.length - 1 ? (
              <Fragment>
                <DynamicLink
                  className="text-black hocus:text-black-active"
                  data-testid={item.dataTestId}
                  onClick={item.onClick}
                  url={item.url}
                >
                  {item.label}
                </DynamicLink>
                <span className="ms-10">&gt;</span>
              </Fragment>
            ) : (
              <span className="font-bold text-sienna">{item.label}</span>
            )}
          </li>
        ))}
    </ul>
  ) : null;
